import React, { useEffect, useState } from "react";
import TableContainer from "../../components/table/table-container";
import Button from "../../components/buttons/button";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/pagination/pagination";
import search from "../../assets/icons/searchIcon.svg";
import { useDispatch } from "react-redux";
import { errorToast, successToast } from "../../components/notifications/toast";
import Loader from "../../components/loaders/dot-loader";
import { exportStoreAction, listStoreAction } from "../../redux/actions/storeAction";
import jsPDF from "jspdf";
import "jspdf-autotable";

const Stores = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState("");
    const [paginationData, setPaginationData] = useState(null);
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(false);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        console.log("Current Page:", page);
    };

    const handleEdit = (id) => {
        navigate(`/stores/edit/${id}`);
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(searchValue);
            setCurrentPage(1)
        }, 300);

        return () => {
            clearTimeout(handler);
        };
    }, [searchValue]);

    useEffect(() => {
        fetchStores()
    }, [currentPage, debouncedValue])

    const fetchStores = () => {
        setLoading(true)
        dispatch(listStoreAction({ page: currentPage, search: debouncedValue }, onSuccess, onError))
    }


    const onSuccess = (data) => {
        setStores(data.data.data.stores);
        setPaginationData(data.data.data.pagination)
        setLoading(false)
    }

    const handleDownloadCustomerPDF = (customers) => {
        const doc = new jsPDF();
        doc.setFontSize(14);

        const tableColumn = [
            "Sl",
            "Store",
            "Owner",
            "Mobile",
            "Address"
        ];

        const tableRows = customers?.map((customer, index) => [
            index + 1,
            customer?.name,
            customer.customer_name,
            customer.customer_mobile,
            customer.address,
        ]);

        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 15,
            styles: { fontSize: 10 },
            headStyles: { fillColor: [23, 37, 84] }, // Tailwind's "navy" equivalent
        });

        doc.save(`Stores.pdf`);
    };

    const downloadStores = () => {
        setLoading(true)
        dispatch(exportStoreAction({}, onDownloadSuccess, onError))
    }

    const onDownloadSuccess = (data) => {
        handleDownloadCustomerPDF(data.data.data);
        setLoading(false);
        successToast("Stores Data Downloaded")
    }



    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
        setLoading(false)
    }

    return (
        <TableContainer>
            <div className="flex flex-col sm:flex-row justify-between px-2 pb-2 w-full">
                <div className="w-full sm:w-auto">
                    {/* Bread crumb data */}
                    <div
                        style={{ height: "2.5rem" }}
                        className={`input_border flex items-center rounded-md w-full sm:w-auto mx-1 md:w-80`}
                    >
                        <span className="px-2">
                            <img width={"16px"} src={search} alt="search icon" />
                        </span>
                        <input
                            placeholder={`Search here`}
                            className="table_search_input w-full rounded-md fs_12 placeholder:text-fs_12"
                            type="text"
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e?.target?.value);
                            }}
                        />
                        <span className='fs_14 mx-3 cursor-pointer text-primary' onClick={() => setSearchValue('')} >Clear</span>
                    </div>
                </div>

                <div className="w-full sm:w-auto mt-2 sm:mt-0 flex gap-2">
                    <Button onClick={() => navigate('/stores/create')} variant="primary" size="md" className="w-full sm:w-auto">
                        Create Store
                    </Button>
                    <Button onClick={downloadStores} variant="primary" size="md" className="w-full sm:w-auto">
                        Download
                    </Button>
                </div>
            </div>

            <div className="relative">
                <div className="overflow-auto border border-gray-300 rounded-md" style={{ height: '45rem' }}>
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-100 sticky top-0">
                                <th className="p-2 border border-gray-200 font-medium text-left">#</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Code</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Store Image</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Store Name</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Customer Name</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Mobile</th>
                                <th className="p-2 border border-gray-200 font-medium">Address</th>
                                <th className="p-2 border border-gray-200 font-medium ">Created By</th>
                                <th className="p-2 border border-gray-200 font-medium text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="10" style={{ height: '35rem' }}>
                                        <Loader />
                                    </td>
                                </tr>
                            ) : stores.length > 0 ? stores.map((store, index) => (
                                <tr key={store.id} className="hover:bg-gray-50">
                                    <td className="px-2 border border-gray-200">{(currentPage - 1) * paginationData?.pageSize + (index + 1)}</td>
                                    <td className="px-2 border border-gray-200 text-left">{store?.code}</td>
                                    <td className="px-2 border border-gray-200">
                                        {store?.image ?
                                            <img
                                                src={store?.image}
                                                alt={store?.name}
                                                className="w-16 h-14 object-cover rounded-md truncate"
                                            />
                                            : <div className="py-2">--</div>
                                        }
                                    </td>
                                    <td className="px-2 border border-gray-200 text-left">{store?.name}</td>
                                    <td className="px-2 border border-gray-200 text-left">{store?.customer_name}</td>
                                    <td className="px-2 border border-gray-200 text-left">{store?.customer_mobile}</td>
                                    <td className="px-2 border border-gray-200">{store?.address}</td>
                                    <td className="p-3 border border-gray-200 ">{store?.createdBy ? store?.createdBy?.name : store?.admin?.name}</td>
                                    <td className="px-2 border border-gray-200 text-center">

                                        <button
                                            onClick={() => navigate(`/stores/view/${store?.id}`)}
                                            className="text-blue-500 hover:underline"
                                        >
                                            View
                                        </button>

                                        <button
                                            onClick={() => handleEdit(store?.id)}
                                            className="text-primary hover:underline mx-2"
                                            style={{ color: "#1E40AF" }}
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                            )) :
                                <tr>
                                    <td colSpan="10" style={{ height: '35rem' }}>
                                        <span className="text-gray-400 font-extralight"> No Data Found</span>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="flex justify-end mt-2 bottom-0 right-0">
                <Pagination
                    totalPages={paginationData?.totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            </div>
        </TableContainer>
    );
};

export default Stores;
